import { Alert, Button, Modal } from '@/components/ds2'
import type { TmsTruckSeatLimitPrompt } from './overagePrice'

interface TmsTruckSeatLimitModalProps {
    prompt: TmsTruckSeatLimitPrompt | null
    loading?: boolean
    onClose: () => void
    onConfirm: () => void
    onUpgrade: () => void
}

export const TmsTruckSeatLimitModal = ({ prompt, loading = false, onClose, onConfirm, onUpgrade }: TmsTruckSeatLimitModalProps) => {
    const canConfirmOverage = prompt?.kind === 'active'

    return (
        <Modal
            open={!!prompt}
            onClose={onClose}
            size="sm"
            data-testid="tms-truck-seat-limit-modal"
            header={<h3 className="text-xl font-semibold text-foreground">{prompt?.title}</h3>}
            footer={
                <>
                    <Button variant="outline" onClick={onClose} disabled={loading}>
                        {canConfirmOverage ? 'Cancel' : (prompt?.secondaryLabel ?? 'Cancel')}
                    </Button>
                    {canConfirmOverage ? (
                        <Button variant="primary" onClick={onConfirm} loading={loading}>
                            {prompt?.actionLabel ?? 'Confirm'}
                        </Button>
                    ) : (
                        <Button variant="primary" onClick={onUpgrade} disabled={loading}>
                            {prompt?.actionLabel ?? 'Upgrade plan'}
                        </Button>
                    )}
                </>
            }
        >
            {prompt && (
                <Alert
                    variant={canConfirmOverage ? 'warning' : 'danger'}
                    title={canConfirmOverage ? 'This will change your bill' : 'Plan limit reached'}
                    description={prompt.message}
                />
            )}
        </Modal>
    )
}
